export default __webpack_public_path__ + "static/media/redo_icon.a1773c10.svg";